import React from 'react'

const Footer = () => {
  return (
    <div className=" text-center bg-dark  mt-1">
      <p className='text-white p-2 mb-0 fs-6'>© Copyright 2025 HKCL. All Rights Reserved</p>
    </div>
  )
}

export default Footer
